module.exports = __webpack_public_path__ + "3769d360f06da122d45b68759fbc710a.svg";